<div class="row mb-0" [formGroup]="form">
  <div class="col-12 col-sm-6 mb-3">
    <lib-gung-select-option-input
      gungTranslate="PARTNER_AGREEMENT"
      [optionsList]="partnerAgreementOptionsList"
      formControlName="agreementId"
    ></lib-gung-select-option-input>
    <lib-forms-message-error [controller]="form.get('agreementId')"></lib-forms-message-error>
  </div>

  <div class="col-12 col-sm-6 mb-3">
    <lib-gung-date-picker
      [currentselectedDate]="form.get('workPerformedDate').value"
      (selectedDate)="form.get('workPerformedDate').setValue($event)"
      label="WORK_PERFORMED_DATE"
    ></lib-gung-date-picker>
    <lib-forms-message-error [controller]="form.get('workPerformedDate')"></lib-forms-message-error>
  </div>
</div>

<div class="row" [formGroup]="form">
  <div class="col-12 col-sm-6 mb-3">
    <lib-gung-text-input
      gungTranslate="REG_NR_WORKING_ORDER"
      formControlName="regNr"
      [placeholder]="''"
    ></lib-gung-text-input>
    <lib-forms-message-error [controller]="form.get('regNr')"></lib-forms-message-error>
  </div>

  <div class="col-12 col-sm-6 mb-3">
    <lib-gung-input-multi-select
      label="REASON_FOR_WORK"
      [optionsList]="reasonForWorkOptionsList"
      (selectedValues)="form.get('reasonForWork').setValue($event)"
      [previewField]="'name'"
    ></lib-gung-input-multi-select>
    <lib-forms-message-error [controller]="form.get('reasonForWork')"></lib-forms-message-error>
  </div>
</div>

<div class="row" [formGroup]="form">
  <div class="col-12 col-sm-6 mb-3" formGroupName="extra">
    <lib-gung-text-area-input
      gungTranslate="WORKING_ORDER_COMMENT"
      formControlName="comment"
      [rowsNumber]="5"
    ></lib-gung-text-area-input>
  </div>
</div>

<div class="row">
  <div class="col-12">
    <div class="alert alert-info mt-4">
      <p translate>WORKING_ORDER_STEP_INFO_1</p>
    </div>
  </div>
</div>
